// extracted by mini-css-extract-plugin
export default {"avatar":"AvatarCell_avatar__uDzOe"};